import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import ReusableModal from "../../../components/Models/ReusableModal";
// import Table from '../../../components/Table';
import {
    Settings2,
    Eye,
    SquarePen,
    RadioTower,
    Trash2,
    Download,
    ArrowDownToLine,
    RefreshCcw,
    ShoppingCart
} from "lucide-react";

import {
    deleteClient,
    UpdateClientStatus,
    PlanSubscription,
    getActivecategoryplan,
    getplanlist,
    BasketSubscription,
    BasketAllList,
    getcategoryplan,
    getPlanbyUser,
    AllclientFilter,
    getclientExportfile,
    BasketAllActiveList,
    BasketListbyUser,
    Kycverfiedbyadmin,
    basicsettinglist,
    getstaffperuser
} from "../../../Services/Admin/Admin";
import { GetUserData } from "../../../Services/UserService/User";

import { Tooltip } from "antd";
import { fDateTime } from "../../../../Utils/Date_formate";
import { image_baseurl } from "../../../../Utils/config";
import { IndianRupee } from "lucide-react";
import { exportToCSV } from "../../../../Utils/ExportData";
import Table from "../../../Extracomponents/Table1";
import Loader from "../../../../Utils/Loader";
import showCustomAlert from "../../../Extracomponents/CustomAlert/CustomAlert";
import { GetCouponlist, ApplyCoupondata, GetBasketCouponList, ApplyBasketCoupon } from "../../../Services/UserService/User";
import { Modal, Accordion, Form } from "react-bootstrap";

const admin_id = localStorage.getItem("id");


const Client = () => {

    const userid = localStorage.getItem('id');
  const [userdata, setUserdata] = useState([]);


    const applyButtonRef = useRef(null);
    const basketApplyButtonRef = useRef(null);


    useEffect(() => {
        getbasketlist();
        getcategoryplanlist();
        // getActiveBasketdetail();
        getkeybydata();
        getpermissioninfo();
    }, []);



    const location = useLocation();
    const clientStatus = location?.state?.clientStatus;

    const token = localStorage.getItem("token");
    const navigate = useNavigate();



    const [category, setCategory] = useState([]);
    const [checkedIndex, setCheckedIndex] = useState(0);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [clients, setClients] = useState([]);
    const [planlist, setPlanlist] = useState([]);
    const [basketlist, setBasketlist] = useState([]);
    const [client, setClientid] = useState({});
    const [selectcategory, setSelectcategory] = useState(null);
    const [searchInput, setSearchInput] = useState("");
    const [selectedPlanId, setSelectedPlanId] = useState(null);
    const [ForGetCSV, setForGetCSV] = useState([]);
    const [searchkyc, setSearchkyc] = useState("");
    const [statuscreatedby, setStatuscreatedby] = useState("");
    const [header, setheader] = useState("Client");
    const [expired, setExpired] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [totalRows, setTotalRows] = useState(0);
    const [getBasket, setGetBasket] = useState({});

    const [kycmodel, SetKycmodel] = useState(false)
    const [kycid, setKycid] = useState("")
    const [kycdocID, setKycdocId] = useState("")
    const [isLoading, setIsLoading] = useState(true);


    const [appliedCoupon, setAppliedCoupon] = useState(null);
    const [manualCoupon, setManualCoupon] = useState("");
    const [coupons, setCoupon] = useState([]);
    const [basicdata, setBasicdata] = useState([])
    const [couponModel, setCouponModel] = useState(false);
    const [plandata, setPlandata] = useState("")
    const [coupondata, setCouponData] = useState("");
    const [discountedPrice, setDiscountedPrice] = useState(0);
    const [permission, setPermission] = useState([]);

    const [coupondetails, setCoupondetails] = useState({})


    const [loading, setLoading] = useState(false);

    // ---- ✅ Basket coupon states (new) ----
    const [basketCouponModel, setBasketCouponModel] = useState(false);
    const [basketCoupons, setBasketCoupons] = useState([]);
    const [basketManualCoupon, setBasketManualCoupon] = useState("");
    const [basketAppliedCoupon, setBasketAppliedCoupon] = useState(null);
    const [basketCouponData, setBasketCouponData] = useState("");
    const [basketCoupondetails, setBasketCoupondetails] = useState({});
    const [selectedBasketData, setSelectedBasketData] = useState(null);


    const handlePageChange = (page) => {
        setCurrentPage(page);
    };



 const fetchUserData = async (id) => {
    try {
      const userData = await GetUserData(id, token);
      if (userData && userData.data) {
        setUserdata(userData.data);
      }
    } catch (error) {
      showCustomAlert(
        "error",
        "Failed to load user data. Please refresh and try again."
      );
    }
  };

  // useEffect(() => {
  //   fetchUserData();
  // }, []);

    const getCoupon = async (clientId) => {
        try {
            if (!clientId) return;
            const response = await GetCouponlist(clientId, token);
            if (response.status) {
                setCoupon(response?.data);
            }
        } catch (error) {
            console.error("Error fetching coupons:", error);
        }
    };

    // ✅ Fetch basket coupons
    const getBasketCoupons = async () => {
        try {
            const response = await GetBasketCouponList({}, token);
            if (response.status) {
                setBasketCoupons(response?.data);
            }
        } catch (error) {
            console.error("Error fetching basket coupons:", error);
        }
    };


    const getpermissioninfo = async () => {
        try {
            const response = await getstaffperuser(userid, token);
            if (response.status) {
                setPermission(response.data.permissions);
            }
        } catch (error) {
            console.log("error", error);
        }
    }



    const getkeybydata = async () => {
        try {
            const response = await basicsettinglist();

            if (response.status) {
                setBasicdata(response.data[0])
            }
        } catch (error) {
            console.error("Error fetching coupons:", error);
        }
    };


    const handleCouponSelect = (coupon) => {
        setManualCoupon(coupon?.code);
        setCouponData(coupon);
        if (applyButtonRef.current) {
            applyButtonRef.current.focus();
        }
    };



    const handleCloseModal = () => {
        setCouponModel(false);
        setPlandata(null);
        setDiscountedPrice(0);
        setManualCoupon("")
        setAppliedCoupon(null)
        setCoupondetails({})

    };




    const removeCoupon = () => {
        setManualCoupon("");
        setAppliedCoupon(null);
        setDiscountedPrice(plandata?.price || "N/A");
        setCoupondetails({});

    };



    // FIXED COUPON CALCULATION FUNCTION
    const applyCoupon = async (coupon) => {
        try {
            const data = {
                code: coupon?.code || coupon,
                purchaseValue: plandata?.price,
                planid: plandata._id,
                client_id: client?._id,
            };
            const response = await ApplyCoupondata(data, token);

            if (response.status) {
                showCustomAlert("Success", response.message || "Your discount has been applied successfully.")
                setCoupondetails(response)
                if (typeof coupon === 'string') {
                    setAppliedCoupon({ code: coupon });
                } else {
                    setAppliedCoupon(coupondata || coupon);
                }
            } else {
                showCustomAlert("error", response?.message || "Failed to apply coupon. Please try again.")
            }
        } catch (error) {
            showCustomAlert("error", "Something went wrong. Please try again later.");
        }
    };

    // ---- ✅ Basket coupon handlers (new - mirror of plan coupon handlers) ----
    const handleBasketCouponSelect = (coupon) => {
        setBasketManualCoupon(coupon?.code);
        setBasketCouponData(coupon);
        if (basketApplyButtonRef.current) {
            basketApplyButtonRef.current.focus();
        }
    };

    const handleCloseBasketCouponModal = () => {
        setBasketCouponModel(false);
        setSelectedBasketData(null);
        setBasketManualCoupon("");
        setBasketAppliedCoupon(null);
        setBasketCoupondetails({});
        setBasketCouponData("");
    };

    const removeBasketCoupon = () => {
        setBasketManualCoupon("");
        setBasketAppliedCoupon(null);
        setBasketCoupondetails({});
    };

    const applyBasketCoupon = async (coupon) => {
        try {
            const data = {
                code: coupon?.code || coupon,
                purchaseValue: selectedBasketData?.basket_price,
                client_id: client?._id,
            };
            const response = await ApplyBasketCoupon(data, token);

            if (response.status) {
                showCustomAlert(
                    "Success",
                    response.message || "Your discount has been applied successfully.",
                );
                setBasketCoupondetails(response);
                if (typeof coupon === "string") {
                    setBasketAppliedCoupon({ code: coupon });
                } else {
                    setBasketAppliedCoupon(basketCouponData || coupon);
                }
            } else {
                showCustomAlert(
                    "error",
                    response?.message || "Failed to apply coupon. Please try again.",
                );
            }
        } catch (error) {
            showCustomAlert("error", "Something went wrong. Please try again later.");
        }
    };


    // REMOVED UNUSED getCouponDiscountAmount FUNCTION






    useEffect(() => {
        if (clientStatus == 1) {
            setheader("Active Client");
        } else if (clientStatus == 0) {
            setheader("Deactive Client");
        } else if (clientStatus === "active") {
            setheader("Total Plan Active Client");
        } else if (clientStatus === "expired") {
            setheader("Total Plan Expired Client");
        }
    }, [clientStatus, clients]);



    const handleDownload = (row) => {
        const url = `${image_baseurl}uploads/pdf/${row.pdf}`;
        const link = document.createElement("a");
        link.href = url;
        link.target = "_blank";

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };




    const [basketdetail, setBasketdetail] = useState({
        basket_id: "",
        client_id: "",
        price: "",
    });




    const [updatetitle, setUpdatetitle] = useState({
        plan_id: "",
        client_id: "",
        price: "",
    });

    const [filters, setFilters] = useState({
        fromDate: '',
        toDate: '',
        service: '',
        stock: '',
    });





    const handleTabChange = (index) => {
        setCheckedIndex(index);
    };

    const showModal = () => {
        setIsModalVisible(true);
    };

    const handleCancel = () => {
        setCouponModel(false)
        setIsModalVisible(false);
        setSelectcategory("");
        setSelectedPlanId("")
        setManualCoupon("");
        setAppliedCoupon(null);
        setCoupondetails({});
        // ✅ Also reset basket coupon states on main modal close
        setBasketManualCoupon("");
        setBasketAppliedCoupon(null);
        setBasketCoupondetails({});
        setBasketCouponData("");
        setSelectedBasketData(null);
    };

    const handleCategoryChange = (categoryId) => {
        setSelectcategory(categoryId);
        setSelectedPlanId(null);
        setUpdatetitle("");
    };

    const resethandle = () => {
        setSearchkyc("");
        setSearchInput("");
        setStatuscreatedby("");
        setExpired("");
        setCurrentPage(1);
        setFilters({
            fromDate: '',
            toDate: '',
            service: '',
            stock: '',
        });

    };

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilters((prev) => ({ ...prev, [name]: value }));
    };

    useEffect(() => {
        setCurrentPage(1);
    }, [searchInput, searchkyc, statuscreatedby, expired]);


    useEffect(() => {
        if (permission.length > 0) {
            const timer = setTimeout(() => {
                getAdminclient();
            }, 500);
            return () => clearTimeout(timer);
        }
    }, [searchInput, searchkyc, statuscreatedby, currentPage, expired, filters.fromDate, filters.toDate]);





    useEffect(() => {
        if (permission.length > 0) {
            getAdminclient();
        }
    }, [permission, searchkyc, statuscreatedby, currentPage, expired, filters.fromDate, filters.toDate]);



    const getexportfile = async () => {
        try {
            const data = {
                page: currentPage,
                kyc_verification: searchkyc,
                status: clientStatus == 1 ? 1 : clientStatus == 0 ? 0 : "",
                createdby: statuscreatedby,
                search: searchInput,
                planStatus:
                    expired === "active"
                        ? "active"
                        : expired === "expired"
                            ? "expired"
                            : clientStatus === "active"
                                ? "active"
                                : clientStatus === "expired"
                                    ? "expired"
                                    : expired === "NA"
                                        ? "NA"
                                        : "",
                add_by: permission.includes("Ownclient") ? userid : "",
                fromDate: filters.fromDate,
                toDate: filters.toDate,
            };

            const response = await getclientExportfile(data, token);
            if (response.status) {
                if (response.data?.length > 0) {
                    const csvArr = response.data.map((item) => {
                        const utm = item?.utmSource?.toLowerCase() || "";

                        let utmSourceLabel = "google-play";
                        if (utm.includes("instagram")) utmSourceLabel = "Instagram";
                        else if (utm.includes("facebook")) utmSourceLabel = "Facebook";

                        return {
                            UtmSource: utmSourceLabel,
                            FullName: item?.FullName || "N/A",
                            Email: item?.Email || "N/A",
                            kyc_verification: item?.kyc_verification === 1 ? "Verified" : "Not Verified",
                            PlanStatus: item?.plansStatus?.some((statusItem) => statusItem.status === "active")
                                ? "Active"
                                : item?.plansStatus?.some((statusItem) => statusItem.status === "expired")
                                    ? "Expired"
                                    : "N/A",
                            ClientActiveSegment:
                                item?.plansStatus
                                    ?.filter((statusItem) => statusItem.status === "active")
                                    .map((statusItem) => statusItem.serviceName || "N/A")
                                    .join(", ") || "N/A",
                            ClientExpiredSegment:
                                item?.plansStatus
                                    ?.filter((statusItem) => statusItem.status === "expired")
                                    .map((statusItem) => statusItem.serviceName || "N/A")
                                    .join(", ") || "N/A",
                            CreatedBy:
                                item?.addedByDetails?.FullName ||
                                (item?.clientcome === 1 ? "WEB" : "APP") ||
                                "N/A",
                            PhoneNo: item?.PhoneNo || "N/A",
                            State: item?.state || "N/A",
                            Created_at: fDateTime(item?.createdAt) || "N/A",
                        };
                    });

                    exportToCSV(csvArr, "All Clients");
                } else {
                    console.log("No data available.");
                }
            } else {
                console.error("Failed to fetch data:", response.status);
            }
        } catch (error) {
            console.error("Error fetching clients:", error);
        }
    };






    const getcategoryplanlist = async () => {
        try {
            const response = await getActivecategoryplan(token);

            if (response.status) {
                setCategory(response.data);
            }
        } catch (error) {
            console.log("error");
        }
    };




    const setkycverified = async () => {
        try {
            const data = { id: kycid._id, doc_id: kycdocID }
            const response = await Kycverfiedbyadmin(data, token);
            if (response.status) {
                showCustomAlert("Success", response.message)
                SetKycmodel(false)
                setKycdocId("")
            } else {
                showCustomAlert("error", response.message)
            }
        } catch (error) {
            showCustomAlert("error", error.message)
        }
    };







    const getAdminclient = async () => {
        try {
            setIsLoading(true)
            const data = {
                page: currentPage,
                kyc_verification: searchkyc,
                status: clientStatus == 1 ? 1 : clientStatus == 0 ? 0 : "",
                createdby: statuscreatedby,
                search: searchInput,
                planStatus:
                    expired === "active"
                        ? "active"
                        : expired === "expired"
                            ? "expired"
                            : clientStatus === "active"
                                ? "active"
                                : clientStatus === "expired"
                                    ? "expired"
                                    : expired === "NA" ? "NA" : "",
                add_by: permission.includes("Ownclient") ? userid : "",
                fromDate: filters.fromDate,
                toDate: filters.toDate,
            };
            const response = await AllclientFilter(data, token);

            if (response.status) {
                setClients(response.data);
                setTotalRows(response.pagination.total);
            }
        } catch (error) {
            console.error("Error fetching clients:", error);
        }
        finally {
            setIsLoading(false)

        }
    };




    const getplanlistassinstatus = async (_id) => {
        try {
            const response = await getPlanbyUser(_id, token);
            if (response.status) {
                setPlanlist(response.data);

            }
        } catch (error) {
            console.log("error");
        }
    };



    const getActiveBasketdetail = async (_id) => {
        try {
            const response = await BasketListbyUser(_id, token);
            if (response.status) {
                setGetBasket(response.data);

            }
        } catch (error) {
            console.log("error");
        }
    };





    const getbasketlist = async () => {
        try {
            const response = await BasketAllList(token);
            if (response.status) {
                setBasketlist(response.data);
            }
        } catch (error) {
            console.log("error");
        }
    };

    const updateClient = async (row) => {
        navigate("/employee/client/updateclient/" + row._id, { state: { row } });
    };

    const signaldetail = async (row) => {
        navigate("/employee/clientsignaldetail/" + row._id, { state: { row } });
    };

    const Clientdetail = async (row) => {
        navigate("/employee/client/clientdetail/" + row._id, { state: { row } });
    };



    const viewcart = async (row) => {
        navigate("/employee/cartlist/" + row._id);
    };





    // update status
    const handleSwitchChange = async (event, id) => {
        const originalChecked = event.target.checked;
        const user_active_status = originalChecked ? "1" : "0";
        const data = { id, status: user_active_status };

        const result = await showCustomAlert("confirm", "Do you want to save the changes?");
        if (!result.isConfirmed) return;

        try {
            const response = await UpdateClientStatus(data, token);
            if (response.status) {
                showCustomAlert("success", "Status Changed");
            }
            getAdminclient();
        } catch (error) {
            showCustomAlert("error", "There was an error processing your request.");
        }
    };






    const Updateplansubscription = async () => {

 if (!userdata?.Email) {
        showCustomAlert("error", "Please Complete The User Profile");
        return;
      }


        setLoading(true);
        try {
            const data = {
                plan_id: updatetitle.plan_id,
                client_id: client._id,
                price: updatetitle.price,
                discount: coupondetails?.discount || 0,
                coupon_code: manualCoupon,
                add_by: admin_id
            };

            const response = await PlanSubscription(data, token);
            if (response && response.status) {
                showCustomAlert("success", response.message);
                setUpdatetitle({ plan_id: "", client_id: "", price: "" });
                setCurrentPage(1);
                getAdminclient();
                handleCancel();
            } else {
                showCustomAlert("error", response.message);
            }
        } catch (error) {
            showCustomAlert("error", "Server error");
        }
        finally {
            setLoading(false);

        }
    };



    // assign basket
    const UpdateBasketservice = async () => {
        try {
            if (!userdata?.Email) {
                showCustomAlert("error", "Please Complete The User Profile");
                return;
            }

            setLoading(true);
            const data = {
                basket_id: basketdetail.basket_id,
                client_id: client._id,
                price: basketdetail.price,
                discount: basketCoupondetails?.discount || 0,
                coupon_code: basketManualCoupon,
            };
            const response = await BasketSubscription(data, token);
            if (response && response.status) {
                showCustomAlert("Success", "Basket service updated successfully.");
                setBasketdetail({ basket_id: "", client_id: "", price: "" });
                getAdminclient();
                handleCancel();
                handleCloseBasketCouponModal();
            } else {
                showCustomAlert("error", response.message);
            }
        } catch (error) {
            showCustomAlert("error", "There was an error updating the Basket.");
        }
        finally {
            setLoading(false);

        }
    };




    const columns = [
        {
            name: "S.No",
            selector: (row, index) => (currentPage - 1) * 10 + index + 1,
            sortable: false,
            width: "100px",
        },
        {
            name: "Utm Source",
            selector: (row) => {
                if (!row.utmSource) return "google-play";
                if (row.utmSource.includes("instagram")) return "Instagram";
                if (row.utmSource.includes("facebook")) return "Facebook";
                return "google-play";
            },
            sortable: true,
            width: "200px",
        },
        {
            name: "Full Name",
            selector: (row) => row.FullName,
            sortable: true,
            width: "200px",
        },

        {
            name: "Email",
            selector: (row) => row.Email,
            sortable: true,
            width: "350px",
        },
        {
            name: "Phone No",
            selector: (row) => row.PhoneNo,
            sortable: true,
            width: "200px",
        },
        {
            name: "State",
            selector: (row) => (row.state || "-"),
            sortable: true,
            width: "200px",
        },
        {
            name: "Plan Status",
            cell: (row) => {
                const hasActive = row?.plansStatus?.some((item) => item.status === "active");
                const hasExpired = row?.plansStatus?.some((item) => item.status === "expired");

                let statusText = "N/A";
                let className = "badge bg-warning text-dark";

                if (hasActive) {
                    statusText = "Active";
                    className = "badge bg-success ";
                } else if (hasExpired) {
                    statusText = "Expired";
                    className = "badge bg-danger";
                }

                return <span className={className}>{statusText}</span>;
            },
            sortable: true,
            idth: "200px",
        },
        {
            name: "Client Segment",
            cell: (row) => {
                if (!Array.isArray(row?.plansStatus) || row.plansStatus.length === 0) {
                    return <span>N/A</span>;
                }

                return (
                    <div style={{ display: "flex", flexWrap: "wrap" }}>
                        {row.plansStatus.map((item, index) => (
                            <div
                                key={index}
                                style={{
                                    marginBottom: "5px",
                                    color:
                                        item.status === "active"
                                            ? "green"
                                            : item.status === "expired"
                                                ? "red"
                                                : "inherit",
                                }}
                            >
                                {item.serviceName || "N/A"}
                                {index < row.plansStatus.length - 1 ? ", " : ""}
                            </div>
                        ))}
                    </div>
                );
            },
            sortable: true,
            width: "200px",
        },
        {
            name: "Created By",
            selector: (row) =>
                row.addedByDetails?.FullName ?? (row.clientcome === 1 ? "WEB" : "APP"),
            sortable: true,
            width: "165px",
        },

        permission.includes("clientchangestatus") && {
            name: "Active Status",
            selector: (row) => (
                <div className="form-check form-switch form-check-info">
                    <input
                        id={`rating_${row._id}`}
                        className="form-check-input toggleswitch"
                        type="checkbox"
                        checked={row.ActiveStatus == 1}
                        onChange={(event) => handleSwitchChange(event, row._id)}
                    />
                    <label
                        htmlFor={`rating_${row._id}`}
                        className="checktoggle checkbox-bg"
                    ></label>
                </div>
            ),
            sortable: true,
            width: "165px",
        },

        // {
        //   name: "Kyc",
        //   selector: (row) =>
        //     row.kyc_verification === 1 ? (
        //       <div
        //         style={{ color: "green", cursor: "pointer" }}
        //         onClick={() => handleDownload(row)}
        //       >
        //         <Tooltip placement="top" overlay="Download">
        //           Verified <ArrowDownToLine />
        //         </Tooltip>
        //       </div>
        //     ) : (
        //       <div style={{ color: "red" }}>Not Verified</div>
        //     ),
        //   sortable: true,
        //   width: "160px",
        // },
        {
            name: "Kyc",
            selector: (row) =>
                row.kyc_verification == 1 ? (
                    <div style={{ color: "green", cursor: "pointer" }} onClick={() => handleDownload(row)}>
                        <Tooltip placement="top" overlay="Download">
                            Verified <ArrowDownToLine />
                        </Tooltip>
                    </div>
                ) : (
                    <div style={{ color: "red" }}>Not Verified <Eye
                        onClick={() => { SetKycmodel(true); setKycid(row) }}
                    />
                    </div>
                ),
            sortable: true,
            width: "160px",
        },
        {
            name: "CreatedAt",
            selector: (row) => fDateTime(row.createdAt),
            sortable: true,
            width: "200px",
        },
        // {
        //     name: 'Signal Detail',
        //     selector: (row) => (
        //         <div className='d-flex'>

        //             <Tooltip placement="top" overlay="Signal Detail">
        //                 <span onClick={(e) => { signaldetail(row) }} style={{ cursor: 'pointer' }}>
        //                     <RadioTower />
        //                 </span>
        //             </Tooltip>
        //         </div>
        //     ),
        //     ignoreRowClick: true,
        //     allowOverflow: true,
        //     button: true,
        //     width: '165px',
        // },


        permission.includes("assignPackage") ||
            permission.includes("viewdetail") ||
            permission.includes("editclient") ? {
            name: "Actions",
            selector: (row) => (
                <div className="d-flex justify-content-end gap-2 " >
                    {permission.includes("assignPackage") &&
                        <Tooltip placement="top" overlay="Package Assign">
                            <span
                                onClick={(e) => {
                                    if (row.ActiveStatus === 1) {
                                        showModal(true);
                                        setClientid(row);
                                        getplanlistassinstatus(row._id);
                                        getActiveBasketdetail(row._id);
                                        fetchUserData(row._id);
                                        getCoupon(row._id);
                                    } else {
                                        showCustomAlert("error", "Activate the client first Then assign the package.");
                                    }
                                }}
                                style={{ cursor: "pointer", color: "orange" }}
                            >
                                <Settings2 />
                            </span>
                        </Tooltip>}


                    {permission.includes("viewdetail") && <Tooltip title="view">
                        <Eye onClick={() => Clientdetail(row)}
                            style={{ color: "green" }} />
                    </Tooltip>}

                    {/* <div style={{ marginLeft: "5px" }}>
            <Tooltip title="View Cart">
              <ShoppingCart
                onClick={() => viewcart(row)}
                style={{ color: row.hasPendingCart ? "green" : "red" }}
              />
            </Tooltip>
          </div> */}


                    {permission.includes("editclient") && <Tooltip title="Update">
                        <SquarePen className="" onClick={() => updateClient(row)}
                            style={{ color: "#6f42c1" }}
                        />
                    </Tooltip>}


                    {/* <Tooltip title="delete">
                  <Trash2 onClick={() => DeleteClient(row._id)} />
                </Tooltip> */}


                </div>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
            width: "165px",
        } : "",
    ];

    return (
        <div>
            <div>
                <div className="page-content">
                    <div className="page-breadcrumb  d-flex align-items-center mb-3">
                        <div className="breadcrumb-title pe-3">{header}</div>
                        <div className="ps-3">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb mb-0 p-0">
                                    <li className="breadcrumb-item">
                                        <Link to="/employee/dashboard">
                                            <i className="bx bx-home-alt" />
                                        </Link>
                                    </li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                    <hr />

                    <div className="card">
                        <div className="card-body">
                            <div className="d-lg-flex align-items-center mb-4 gap-3">
                                <div className="position-relative">
                                    <input
                                        type="text"
                                        className="form-control ps-5 radius-10"
                                        placeholder="Search Client"
                                        onChange={(e) => setSearchInput(e.target.value)}
                                        value={searchInput}
                                    />
                                    <span className="position-absolute top-50 product-show translate-middle-y">
                                        <i className="bx bx-search" />
                                    </span>
                                </div>
                                <div className="d-sm-flex gap-3 justify-content-lg-end w-100 mt-3 mt-lg-0">
                                    {permission.includes("addclient") && <div className="flaot-lg-auto">
                                        <Link to="/employee/addclient" className="btn btn-primary">
                                            <i className="bx bxs-plus-square" aria-hidden="true" />
                                            Add Client
                                        </Link>
                                    </div>}

                                    <div className="" onClick={(e) => getexportfile()}>
                                        <button
                                            type="button"
                                            className="btn btn-primary my-2 my-sm-0"
                                            data-toggle="tooltip"
                                            data-placement="top"
                                            title="Export To Excel"
                                            delay={{ show: "0", hide: "100" }}
                                        >
                                            <i className="bx bxs-download" aria-hidden="true"></i>
                                            Export-Excel
                                        </button>
                                    </div>
                                    {/* <div className="">
                                        <Link
                                            to="/admin/clientdeletehistory"
                                            className="btn btn-primary"
                                        >
                                            <i className="bx bxs-trash" aria-hidden="true" />
                                            Deleted Client
                                        </Link>
                                    </div> */}
                                </div>
                            </div>
                            <div className="row ">
                                <div className="col-sm-6 col-md-2 mb-3">
                                    <div>
                                        <label htmlFor="kycSelect">Select Kyc</label>
                                        <select
                                            id="kycSelect"
                                            className="form-control radius-10"
                                            value={searchkyc}
                                            onChange={(e) => setSearchkyc(e.target.value)}
                                        >
                                            <option value="1">Verified</option>
                                            <option value="0">Not Verified</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-sm-6  col-md-2 mb-3">
                                    <div>
                                        <label htmlFor="kycSelect">Select CreatedBy</label>
                                        <select
                                            id="CreatedBy"
                                            className="form-control radius-10"
                                            value={statuscreatedby}
                                            onChange={(e) => setStatuscreatedby(e.target.value)}
                                        >
                                            <option value="">Select Created By</option>
                                            <option value="web">Web</option>
                                            <option value="app">App</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-sm-6  col-md-2 mb-3">
                                    <div>
                                        <label htmlFor="kycSelect">Select Client</label>
                                        <select
                                            id="CreatedBy"
                                            className="form-control radius-10"
                                            value={expired}
                                            onChange={(e) => setExpired(e.target.value)}
                                        >
                                            <option value="">Select Client</option>
                                            <option value="active">Active</option>
                                            <option value="expired">Expired </option>
                                            <option value="NA">N/A</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-2 mb-3">
                                    <label>From date</label>
                                    <input
                                        type="date"
                                        name="fromDate"
                                        className="form-control radius-10"
                                        value={filters.fromDate}
                                        onChange={handleFilterChange}
                                    />
                                </div>
                                <div className="col-md-2 mb-3">
                                    <label>To Date</label>
                                    <input
                                        type="date"
                                        name="toDate"
                                        className="form-control radius-10"
                                        value={filters.toDate}
                                        onChange={handleFilterChange}
                                        min={filters.fromDate}
                                    />
                                </div>
                                <div className="col-sm-6 col-md-1">
                                    <div className="refresh-icon ">
                                        <RefreshCcw onClick={resethandle} />
                                    </div>
                                </div>
                            </div>

                            {isLoading ? (
                                <Loader />
                            ) : clients.length > 0 ? (
                                <Table
                                    columns={columns}
                                    data={clients}
                                    totalRows={totalRows}
                                    currentPage={currentPage}
                                    onPageChange={handlePageChange}
                                />
                            ) : (
                                <div className="text-center mt-5">
                                    <img src="/assets/images/nodata.png" alt="No Records Found" className="w-25" />
                                </div>
                            )}

                        </div>
                    </div>
                </div>
            </div>




            <ReusableModal
                show={isModalVisible}
                onClose={() => handleCancel()}
                title={<> Assign Package</>}
                size="xl"
                body={
                    <>
                        <div className="card border mb-3" style={{ backgroundColor: "#3b3e4c" }}>
                            <div className="d-flex justify-content-center align-items-center card-body">
                                {["Plan", "Basket"].map((tab, index) => (
                                    <label key={index} className="labelfont text-light mx-3">
                                        <input
                                            style={{ marginLeft: "12px" }}
                                            type="radio"
                                            name="tab"
                                            checked={checkedIndex === index}
                                            onChange={() => handleTabChange(index)}
                                            aria-label={`Select ${tab}`}
                                        />
                                        <span className="ps-2 text-light">{tab}</span>
                                    </label>
                                ))}
                            </div>
                        </div>

                        <div className="card border mb-3" >
                            {checkedIndex === 0 && (
                                <>
                                    <div className="row my-3">
                                        {category &&
                                            category
                                                .filter((cat) =>
                                                    planlist.some((plan) => plan.category?._id === cat?._id)
                                                )
                                                .map((item, index) => (
                                                    <div className="col-lg-4 mb-3 d-flex" key={index}>
                                                        <input
                                                            style={{
                                                                border: "1px solid #ddd",
                                                                margin: "0 8px 1px",
                                                                marginTop: "9px"

                                                            }}
                                                            className="form-check-input"
                                                            type="radio"
                                                            name="planSelection"
                                                            id={`proplus-${index}`}
                                                            onClick={() => handleCategoryChange(item?._id)}
                                                        />
                                                        <label
                                                            className="form-check-label"
                                                            htmlFor={`proplus-${index}`}
                                                            style={{
                                                                fontSize: "14px",
                                                                fontWeight: "600",
                                                                color: "#ffffffff",
                                                                marginTop: "8px"

                                                            }}
                                                        >
                                                            {item.title} (
                                                            {item.servicesDetails
                                                                .map((service) => service.title)
                                                                .join(", ")}
                                                            )
                                                        </label>
                                                    </div>
                                                ))}
                                    </div>

                                    {selectcategory && (
                                        <form
                                            className="card-body my-3"
                                            style={{ height: "40vh", overflowY: "scroll" }}
                                        >
                                            <div className="row">
                                                {planlist
                                                    .filter(
                                                        (item) => item.category?._id === selectcategory
                                                    )
                                                    .map((item, index) => (
                                                        <div className="col-md-6 mb-3" key={index}>
                                                            <div className="card mb-0 shadow-sm">
                                                                <div className="card-body p-2">
                                                                    <h5 className="card-title d-flex align-items-center">
                                                                        <input
                                                                            style={{
                                                                                height: "13px",
                                                                                width: "13px",
                                                                                marginTop: "0.50rem",
                                                                                border: "1px solid #ddd",
                                                                            }}
                                                                            className="form-check-input"
                                                                            type="radio"
                                                                            name="planSelection"
                                                                            id={`input-plan-${index}`}
                                                                            checked={selectedPlanId === item?._id}
                                                                            onClick={() => {
                                                                                setSelectedPlanId(item._id);
                                                                                setPlandata(item)
                                                                                setCouponModel(true)
                                                                                setUpdatetitle({
                                                                                    plan_id: item._id,
                                                                                    price: item.price,
                                                                                });
                                                                            }}
                                                                        />
                                                                        <label
                                                                            className="form-check-label mx-2"
                                                                            style={{
                                                                                fontSize: "14px",
                                                                                fontWeight: "700",
                                                                                color: "#ffffffff",
                                                                                marginTop: "8px",

                                                                            }}
                                                                            htmlFor={`input-plan-${index}`}
                                                                        >
                                                                            {item.validity}
                                                                        </label>
                                                                    </h5>

                                                                    <div
                                                                        className="accordion"
                                                                        id={`accordion-${selectcategory}`}
                                                                    >
                                                                        <div className="accordion-item">
                                                                            <h2
                                                                                className="accordion-header"
                                                                                id={`heading-${item._id}`}
                                                                            >
                                                                                <button
                                                                                    className={`accordion-button ${selectedPlanId === item._id
                                                                                        ? ""
                                                                                        : "collapsed"
                                                                                        } custom-accordion-button`}
                                                                                    type="button"
                                                                                    data-bs-toggle="collapse"
                                                                                    data-bs-target={`#collapse-${item._id}`}
                                                                                    aria-expanded={
                                                                                        selectedPlanId === item._id
                                                                                    }
                                                                                    aria-controls={`collapse-${item._id}`}
                                                                                >
                                                                                    <div className="d-flex justify-content-between w-100">
                                                                                        <div>
                                                                                            <strong className="text-light">
                                                                                                Detail
                                                                                            </strong>
                                                                                            <strong className="text-success m-2 activestrong">
                                                                                                {item?.subscription?.status ===
                                                                                                    "active"
                                                                                                    ? "Active"
                                                                                                    : ""}
                                                                                            </strong>
                                                                                        </div>
                                                                                    </div>
                                                                                </button>
                                                                            </h2>
                                                                            <div
                                                                                id={`collapse-${item._id}`}
                                                                                className={`accordion-collapse collapse ${selectedPlanId === item._id
                                                                                    ? "show"
                                                                                    : ""
                                                                                    }`}
                                                                                aria-labelledby={`heading-${item._id}`}
                                                                                data-bs-parent={`#accordion-${selectcategory}`}
                                                                            >
                                                                                <div className="accordion-body">
                                                                                    <div className="d-flex justify-content-between">
                                                                                        <strong>Price:</strong>
                                                                                        <span style={{ display: "flex", alignItems: "center" }}>
                                                                                            <IndianRupee style={{ fontSize: "18px", width: "18px", height: "18px", marginRight: "3px" }} />
                                                                                            {item.price}
                                                                                        </span>
                                                                                    </div>

                                                                                    <div className="d-flex justify-content-between">
                                                                                        <strong>Validity:</strong>
                                                                                        <span>{item.validity}</span>
                                                                                    </div>
                                                                                    <div className="d-flex justify-content-between">
                                                                                        <strong>Created At:</strong>
                                                                                        <span>
                                                                                            {fDateTime(item.created_at)}
                                                                                        </span>
                                                                                    </div>
                                                                                    <div className="d-flex justify-content-between">
                                                                                        <strong>Updated At:</strong>
                                                                                        <span>
                                                                                            {fDateTime(item.updated_at)}
                                                                                        </span>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                            </div>
                                        </form>
                                    )}
                                </>
                            )}

                            {checkedIndex === 1 && (
                                <>
                                    <div
                                        className="card-body my-3"
                                        style={{ height: "40vh", overflowY: "scroll" }}
                                    >
                                        <div className="row">
                                            {getBasket.map((item, index) => (
                                                <div className="col-md-6 mb-3" key={index}>
                                                    <div className="card mb-0 shadow-sm">
                                                        <div className="card-body p-2">
                                                            <h5 className="card-title d-flex align-items-center">
                                                                <input
                                                                    style={{
                                                                        height: "13px",
                                                                        width: "13px",
                                                                        marginTop: "0.52rem",
                                                                        border: "1px solid #ddd",
                                                                    }}
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name="planSelection"
                                                                    id={`input-plan-${index}`}
                                                                    checked={selectedPlanId === item._id}
                                                                    onClick={() => {
                                                                        if (item?.client_status === "active") {
                                                                            showCustomAlert("error", "The basket is Already Active")
                                                                            return;
                                                                        }
                                                                        setSelectedPlanId(item._id);
                                                                        setSelectedBasketData(item);
                                                                        setBasketdetail({
                                                                            basket_id: item._id,
                                                                            price: item.basket_price,
                                                                        });
                                                                        // ✅ Open basket coupon modal & fetch basket coupons
                                                                        setBasketCouponModel(true);
                                                                        getBasketCoupons();
                                                                    }}
                                                                />
                                                                <label
                                                                    className="form-check-label mx-2"
                                                                    style={{
                                                                        fontSize: "14px",
                                                                        fontWeight: "700",
                                                                        color: "#fff",
                                                                        marginTop: "8px",

                                                                    }}
                                                                    htmlFor={`input-plan-${index}`}
                                                                >
                                                                    {item.title} ({item.themename})
                                                                </label>
                                                            </h5>

                                                            <div
                                                                className="accordion"
                                                                id={`accordion-basket`}
                                                            >
                                                                <div className="accordion-item">
                                                                    <h2
                                                                        className="accordion-header"
                                                                        id={`heading-${item._id}`}
                                                                    >
                                                                        <button
                                                                            className={`accordion-button ${selectedPlanId === item._id
                                                                                ? ""
                                                                                : "collapsed"
                                                                                } custom-accordion-button`}
                                                                            type="button"
                                                                            data-bs-toggle="collapse"
                                                                            data-bs-target={`#collapse-${item._id}`}
                                                                            aria-expanded={
                                                                                selectedPlanId === item._id
                                                                            }
                                                                            aria-controls={`collapse-${item._id}`}
                                                                        >
                                                                            <div className="d-flex justify-content-between w-100">
                                                                                <div>
                                                                                    <strong className=" m-2  text-white">
                                                                                        Detail
                                                                                    </strong>
                                                                                    <strong className="text-success m-2 activestrong">
                                                                                        {item?.client_status ===
                                                                                            "active"
                                                                                            ? "Active"
                                                                                            : ""}
                                                                                    </strong>
                                                                                </div>
                                                                            </div>
                                                                        </button>
                                                                    </h2>
                                                                    <div
                                                                        id={`collapse-${item._id}`}
                                                                        className={`accordion-collapse collapse ${selectedPlanId === item._id ? "show" : ""
                                                                            }`}
                                                                        aria-labelledby={`heading-${item._id}`}
                                                                        data-bs-parent={`#accordion-basket`}
                                                                    >
                                                                        <div className="accordion-body">
                                                                            <div className="d-flex justify-content-between">
                                                                                <strong>Price:</strong>
                                                                                <span>
                                                                                    <IndianRupee style={{ fontSize: "18px", width: "18px", height: "18px", marginRight: "3px" }} /> {item.basket_price}
                                                                                </span>
                                                                            </div>
                                                                            <div className="d-flex justify-content-between">
                                                                                <strong>Validity:</strong>
                                                                                <span>{item.validity}</span>
                                                                            </div>
                                                                            <div className="d-flex justify-content-between">
                                                                                <strong>
                                                                                    Minimum Investment Amount:
                                                                                </strong>
                                                                                <span>
                                                                                    <IndianRupee style={{ fontSize: "18px", width: "18px", height: "18px", marginRight: "3px" }} /> {item?.mininvamount}
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
                    </>
                }
                footer={
                    <>
                        <button
                            className="btn btn-primary rounded-1"
                            onClick={() => handleCancel()}
                        >
                            Cancel
                        </button>
                        {checkedIndex === 1 && (
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={() => UpdateBasketservice()}
                                disabled={loading}
                            >
                                {loading ? "Saving..." : "Save Plan"}
                            </button>
                        )}
                    </>
                }
            />


            <ReusableModal
                show={kycmodel}
                onClose={() => SetKycmodel(false)}
                title="Kyc Verified"
                body={
                    <form>
                        <div className="row">

                            <div className="col-md-12 mb-4">
                                <label htmlFor="message" className="form-label fw-semibold">
                                    Enter Doc ID
                                </label>
                                <input
                                    className="form-control shadow-sm"
                                    placeholder="Write your Doc ID.."
                                    value={kycdocID}
                                    onChange={(e) => setKycdocId(e.target.value)}
                                />

                            </div>
                        </div>
                    </form>
                }
                footer={
                    <>
                        <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={() => SetKycmodel(false)}
                        >
                            Close
                        </button>
                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={setkycverified}
                        >
                            Verify
                        </button>
                    </>
                }
            />



            <Modal
                show={couponModel}
                onHide={handleCloseModal}
                centered size="xxl"
                className="bg-blur"

            >
                <Modal.Header closeButton>
                    <Modal.Title className="text-center w-100 heading-color modal-title h4 ">
                        Plan Details
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {plandata && (
                        <>

                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <h5 className="text-white">
                                    {plandata?.category?.title}
                                </h5>

                                <span className="text-success fw-bold">
                                    <IndianRupee style={{ width: '15%;' }} />{" "}
                                    {plandata?.price}
                                </span>
                            </div>

                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <span>
                                    Validity:
                                </span>
                                <span>{plandata?.validity}</span>
                            </div>


                            <Accordion className="mt-3">
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header>🎟️ Apply Coupon Code</Accordion.Header>
                                    <Accordion.Body
                                        style={{
                                            maxHeight: "230px",
                                            overflowY: "auto",
                                            scrollbarWidth: "thin",
                                            padding: '0',
                                        }}
                                    >
                                        <div  style={{
                        position: "sticky",
                        top: 0,
                        zIndex: 10,
                        padding: "10px",
                        background: "#18221f",
                        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                      }}>
                                            <div className="d-flex align-items-center">
                                                <input
                                                    type="text"
                                                    id="couponInput"
                                                    className="form-control me-2"
                                                    placeholder="Enter coupon code"
                                                    value={manualCoupon}
                                                    onChange={(e) => setManualCoupon(e.target.value)}
                                                />
                                                {manualCoupon && (
                                                    <button
                                                        ref={applyButtonRef}
                                                        className="btn btn-primary"
                                                        onClick={() => applyCoupon(manualCoupon)}
                                                    >
                                                        Apply
                                                    </button>
                                                )}
                                                {appliedCoupon && (
                                                    <button
                                                        className="btn btn-danger ms-2"
                                                        onClick={() => removeCoupon()}
                                                    >
                                                        Remove
                                                    </button>
                                                )}
                                            </div>
                                        </div>

                                        <div className="mt-3 px-2">

                                            {coupons.map((coupon) => (

                                                <li
                                                    key={coupon.code}
                                                   style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            border: "1px solid #dcdcdc",
                            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                            marginBottom: "15px",
                            borderRadius: "12px",
                            padding: "15px 20px",
                            listStyle: "none",
                            transition: "transform 0.2s, box-shadow 0.2s",
                          }}
                          onMouseOver={(e) => {
                            e.currentTarget.style.transform = "scale(1.02)";
                            e.currentTarget.style.boxShadow =
                              "0 6px 12px rgba(0, 0, 0, 0.15)";
                          }}
                          onMouseOut={(e) => {
                            e.currentTarget.style.transform = "scale(1)";
                            e.currentTarget.style.boxShadow =
                              "0 4px 8px rgba(0, 0, 0, 0.1)";
                          }}
                                                >
                                                    <div
                                                        className="btn-primary"
                                                        style={{
                                                            width: "40px",
                                                            height: "160px",

                                                            color: "#fff",
                                                            textAlign: "center",
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            justifyContent: "center",
                                                            alignItems: "center",
                                                            borderTopLeftRadius: "12px",
                                                            borderBottomLeftRadius: "12px",
                                                            padding: "0",
                                                            marginLeft: "-20px",
                                                            marginTop: "-20px",
                                                            marginBottom: "-20px",
                                                        }}
                                                    >
                                                        {coupon?.serviceName
                                                            ?.split("")
                                                            .map((char, index) => (
                                                                <span
                                                                    key={index}
                                                                    style={{
                                                                        display: "block",
                                                                        fontSize: "14px",
                                                                        fontWeight: "bold",
                                                                    }}
                                                                >
                                                                    {char.toUpperCase()}

                                                                </span>
                                                            ))}

                                                    </div>

                                                    <div
                                                        style={{
                                                            flexGrow: 1,
                                                            marginLeft: "15px",
                                                            textAlign: "left",
                                                        }}
                                                    >
                                                        <p
                                                            style={{
                                                                margin: "0 0 5px",
                                                                fontWeight: "500",
                                                                color: "#fff",
                                                                fontSize: "16px",
                                                            }}
                                                        >
                                                            Use code{" "}
                                                            <span
                                                                style={{
                                                                    fontWeight: "700",
                                                                    color: "#007bff",
                                                                    marginLeft: "5px",
                                                                }}
                                                            >
                                                                {coupon?.code}
                                                            </span>
                                                        </p>
                                                        <div style={{ fontSize: "14px", color: "#666" }}>
                                                            <span
                                                                style={{
                                                                    display: "block",
                                                                    marginBottom: "4px",
                                                                }}
                                                            >
                                                                🛡️ Validity:{" "}
                                                                <span
                                                                    style={{
                                                                        fontSize: "12px",
                                                                        fontWeight: "bold",
                                                                    }}
                                                                >
                                                                    {coupon?.enddate?.split("T")[0]}
                                                                </span>
                                                            </span>
                                                            <span
                                                                style={{
                                                                    display: "block",
                                                                    marginBottom: "4px",
                                                                }}
                                                            >
                                                                💸 Save Upto: <strong>
                                                                    {coupon.type === "fixed"
                                                                        ? `₹${coupon?.value}`
                                                                        : `${coupon?.value}%`
                                                                    }
                                                                </strong>
                                                            </span>

                                                            <span style={{ display: "block" }}>
                                                                🛒 Min Purchase:{" "}
                                                                <strong>₹{coupon?.minpurchasevalue}</strong>
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <button
                                                            onClick={() => handleCouponSelect(coupon)}
                                                            className={`btn ${manualCoupon === coupon.code ? "btn-success" : "btn-secondary"}`}
                                                            disabled={manualCoupon === coupon.code}
                                                        >
                                                            {manualCoupon === coupon.code ? "Selected" : "Select"}
                                                        </button>
                                                    </div>
                                                </li>
                                            ))}
                                        </div>
                                    </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>

                            <hr />
                            <div>

                                <div className="d-flex justify-content-between align-items-center mb-2">
                                    <b>Original Price:</b>
                                    <span className="text-primary fw-bold">
                                        <IndianRupee style={{ width: '15%' }} />
                                        {coupondetails?.originalPrice?.toFixed(2) || plandata?.price?.toFixed(2)}
                                    </span>
                                </div>

                                {appliedCoupon && coupondetails?.discount > 0 && (
                                    <div className="d-flex justify-content-between align-items-center text-danger mb-2">
                                        <b>Coupon Discount:</b>
                                        <span className="fw-bold">
                                            - <IndianRupee style={{ width: '15%' }} />
                                            {coupondetails?.discount?.toFixed(2)}
                                        </span>
                                    </div>
                                )}

                                {coupondetails?.totalgst > 0 && (
                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                        <b>💰 GST ({basicdata?.gst}%{basicdata?.gststatus === 0 ? " Inclusive" : ""}):</b>
                                        <span className="text-primary fw-bold">
                                            <IndianRupee style={{ width: '15%' }} />
                                            {coupondetails?.totalgst?.toFixed(2)}
                                        </span>
                                    </div>
                                )}


                                {!appliedCoupon && (basicdata?.gststatus === 1 || basicdata?.gststatus === 0) && (
                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                        <b>💰 GST ({basicdata?.gst}%{basicdata?.gststatus === 0 ? " Inclusive" : ""}):</b>
                                        <span className="text-primary fw-bold">
                                            <IndianRupee style={{ width: '15%' }} />
                                            {basicdata?.gststatus === 1
                                                ? ((plandata?.price * basicdata?.gst) / 100).toFixed(2)
                                                : (plandata?.price - (plandata?.price / (1 + Number(basicdata?.gst) / 100))).toFixed(2)}
                                        </span>
                                    </div>
                                )}

                                <div className="d-flex justify-content-between align-items-center mt-3 py-2 border-top">
                                    <b>Total Price:</b>
                                    <span className="text-success fw-bold">
                                        <IndianRupee style={{ width: '15%' }} />
                                        {coupondetails?.finalPrice
                                            ? coupondetails.finalPrice.toFixed(2)
                                            : (
                                                (plandata?.price || 0) +
                                                (basicdata?.gststatus === 1 ? ((plandata?.price || 0) * basicdata?.gst) / 100 : 0)
                                            ).toFixed(2)
                                        }
                                    </span>
                                </div>
                            </div>

                            <div className="d-flex justify-content-end">
                                <div className="mt-4">
                                    {checkedIndex === 0 && (
                                        <button
                                            type="button"
                                            className="btn btn-primary"
                                            onClick={() => Updateplansubscription()}
                                            disabled={loading}
                                        >
                                            {loading ? "Saving..." : "Save Plan"}
                                        </button>
                                    )}

                                </div>
                            </div>
                        </>
                    )}
                </Modal.Body>
            </Modal>
            {/* ========== ✅ BASKET COUPON MODAL (new - mirror of plan coupon modal) ========== */}
            <Modal
                show={basketCouponModel}
                onHide={handleCloseBasketCouponModal}
                centered
                size="xxl"
                className="bg-blur"
            >
                <Modal.Header closeButton>
                    <Modal.Title className="text-center w-100 heading-color modal-title h4">
                        Basket Details
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {selectedBasketData && (
                        <>
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <h5 className="text-white">
                                    {selectedBasketData?.title} ({selectedBasketData?.themename})
                                </h5>
                                <span className="text-success fw-bold">
                                    <IndianRupee style={{ width: "15%" }} />{" "}
                                    {selectedBasketData?.basket_price}
                                </span>
                            </div>

                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <span>Validity:</span>
                                <span>{selectedBasketData?.validity}</span>
                            </div>

                            <Accordion className="mt-3">
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header>🎟️ Apply Coupon Code</Accordion.Header>
                                    <Accordion.Body
                                        style={{
                                            maxHeight: "230px",
                                            overflowY: "auto",
                                            scrollbarWidth: "thin",
                                            padding: "0",
                                        }}
                                    >
                                        <div
                                            style={{
                                                position: "sticky",
                                                top: 0,
                                                zIndex: 10,
                                                padding: "10px",
                                                boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                                            }}
                                        >
                                            <div className="d-flex align-items-center">
                                                <input
                                                    type="text"
                                                    id="basketCouponInput"
                                                    className="form-control me-2"
                                                    placeholder="Enter coupon code"
                                                    value={basketManualCoupon}
                                                    onChange={(e) =>
                                                        setBasketManualCoupon(e.target.value)
                                                    }
                                                />
                                                {basketManualCoupon && (
                                                    <button
                                                        ref={basketApplyButtonRef}
                                                        className="btn btn-primary"
                                                        onClick={() =>
                                                            applyBasketCoupon(basketManualCoupon)
                                                        }
                                                    >
                                                        Apply
                                                    </button>
                                                )}
                                                {basketAppliedCoupon && (
                                                    <button
                                                        className="btn btn-danger ms-2"
                                                        onClick={() => removeBasketCoupon()}
                                                    >
                                                        Remove
                                                    </button>
                                                )}
                                            </div>
                                        </div>

                                        <div className="mt-3 px-2">
                                            {basketCoupons.map((coupon) => (
                                                <li
                                                    key={coupon.code}
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "space-between",
                                                        border: "1px solid #dcdcdc",
                                                        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                                                        marginBottom: "15px",
                                                        borderRadius: "12px",
                                                        padding: "15px 20px",
                                                        listStyle: "none",
                                                        transition: "transform 0.2s, box-shadow 0.2s",
                                                    }}
                                                    onMouseOver={(e) => {
                                                        e.currentTarget.style.transform = "scale(1.02)";
                                                        e.currentTarget.style.boxShadow =
                                                            "0 6px 12px rgba(0, 0, 0, 0.15)";
                                                    }}
                                                    onMouseOut={(e) => {
                                                        e.currentTarget.style.transform = "scale(1)";
                                                        e.currentTarget.style.boxShadow =
                                                            "0 4px 8px rgba(0, 0, 0, 0.1)";
                                                    }}
                                                >
                                                    <div
                                                        className="btn-primary"
                                                        style={{
                                                            width: "40px",
                                                            height: "115px",
                                                            color: "#fff",
                                                            textAlign: "center",
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            justifyContent: "center",
                                                            alignItems: "center",
                                                            borderTopLeftRadius: "12px",
                                                            borderBottomLeftRadius: "12px",
                                                            padding: "0",
                                                            marginLeft: "-20px",
                                                            marginTop: "-20px",
                                                            marginBottom: "-20px",
                                                        }}
                                                    >

                                                        <span
                                                            style={{
                                                                writingMode: "vertical-rl",
                                                                textOrientation: "upright",
                                                                fontSize: "14px",
                                                                fontWeight: "bold",
                                                                lineHeight: "1.2",
                                                            }}
                                                        >
                                                            BASKET
                                                        </span>
                                                    </div>
                                                    <div
                                                        style={{
                                                            flexGrow: 1,
                                                            marginLeft: "15px",
                                                            textAlign: "left",
                                                        }}
                                                    >
                                                        <p
                                                            style={{
                                                                margin: "0 0 5px",
                                                                fontWeight: "500",
                                                                color: "#ffffffff",
                                                                fontSize: "16px",
                                                            }}
                                                        >
                                                            Use code{" "}
                                                            <span
                                                                style={{
                                                                    fontWeight: "700",
                                                                    color: "#007bff",
                                                                    marginLeft: "5px",
                                                                }}
                                                            >
                                                                {coupon?.code}
                                                            </span>
                                                        </p>
                                                        <div style={{ fontSize: "14px", color: "#666" }}>
                                                            <span
                                                                style={{
                                                                    display: "block",
                                                                    marginBottom: "4px",
                                                                }}
                                                            >
                                                                🛡️ Validity:{" "}
                                                                <span
                                                                    style={{
                                                                        fontSize: "12px",
                                                                        fontWeight: "bold",
                                                                    }}
                                                                >
                                                                    {coupon?.enddate?.split("T")[0]}
                                                                </span>
                                                            </span>
                                                            <span
                                                                style={{
                                                                    display: "block",
                                                                    marginBottom: "4px",
                                                                }}
                                                            >
                                                                💸 Save Upto:{" "}
                                                                <strong>
                                                                    {coupon.type === "fixed"
                                                                        ? `₹${coupon?.value}`
                                                                        : `${coupon?.value}%`}
                                                                </strong>
                                                            </span>
                                                            {coupon.type !== "flat" ? (
                                                                <span style={{ display: "block" }}>
                                                                    🛒 Min Purchase:{" "}
                                                                    <strong>₹{coupon?.minpurchasevalue}</strong>
                                                                </span>
                                                            ) : (
                                                                ""
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <button
                                                            onClick={() => handleBasketCouponSelect(coupon)}
                                                            className={`btn ${basketManualCoupon === coupon.code
                                                                ? "btn-success"
                                                                : "btn-secondary"
                                                                }`}
                                                            disabled={basketManualCoupon === coupon.code}
                                                        >
                                                            {basketManualCoupon === coupon.code
                                                                ? "Selected"
                                                                : "Select"}
                                                        </button>
                                                    </div>
                                                </li>
                                            ))}
                                        </div>
                                    </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>

                            <hr />
                            {/* ✅ Price summary — same structure as plan modal */}
                            <div>
                                <div className="d-flex justify-content-between align-items-center mb-2">
                                    <b>Original Price:</b>
                                    <span className="text-primary fw-bold">
                                        <IndianRupee style={{ width: "15%" }} />
                                        {basketCoupondetails?.originalPrice?.toFixed(2) ||
                                            selectedBasketData?.basket_price?.toFixed(2)}
                                    </span>
                                </div>

                                {basketAppliedCoupon && basketCoupondetails?.discount > 0 && (
                                    <div className="d-flex justify-content-between align-items-center text-danger mb-2">
                                        <b>Coupon Discount:</b>
                                        <span className="fw-bold">
                                            - <IndianRupee style={{ width: "15%" }} />
                                            {basketCoupondetails?.discount?.toFixed(2)}
                                        </span>
                                    </div>
                                )}

                                {basketCoupondetails?.totalgst > 0 && (
                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                        <b>💰 GST ({basicdata?.gst}%{basicdata?.gststatus === 0 ? " Inclusive" : ""}):</b>
                                        <span className="text-primary fw-bold">
                                            <IndianRupee style={{ width: "15%" }} />
                                            {basketCoupondetails?.totalgst?.toFixed(2)}
                                        </span>
                                    </div>
                                )}

                                {!basketAppliedCoupon && (basicdata?.gststatus === 1 || basicdata?.gststatus === 0) && (
                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                        <b>💰 GST ({basicdata?.gst}%{basicdata?.gststatus === 0 ? " Inclusive" : ""}):</b>
                                        <span className="text-primary fw-bold">
                                            <IndianRupee style={{ width: "15%" }} />
                                            {basicdata?.gststatus === 1
                                                ? ((selectedBasketData?.basket_price * basicdata?.gst) / 100).toFixed(2)
                                                : (selectedBasketData?.basket_price - (selectedBasketData?.basket_price / (1 + Number(basicdata?.gst) / 100))).toFixed(2)}
                                        </span>
                                    </div>
                                )}

                                <div className="d-flex justify-content-between align-items-center mt-3 py-2 border-top">
                                    <b>Total Price:</b>
                                    <span className="text-success fw-bold">
                                        <IndianRupee style={{ width: "15%" }} />
                                        {basketCoupondetails?.finalPrice !== undefined &&
                                            basketCoupondetails?.finalPrice !== null
                                            ? Number(basketCoupondetails.finalPrice).toFixed(2)
                                            : (
                                                (selectedBasketData?.basket_price || 0) +
                                                (basicdata?.gststatus === 1
                                                    ? ((selectedBasketData?.basket_price || 0) *
                                                        basicdata?.gst) /
                                                    100
                                                    : 0)
                                            ).toFixed(2)}
                                    </span>
                                </div>
                            </div>

                            <div className="d-flex justify-content-end">
                                <div className="mt-4">
                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={() => UpdateBasketservice()}
                                        disabled={loading}
                                    >
                                        {loading ? "Saving..." : "Save Basket"}
                                    </button>
                                </div>
                            </div>
                        </>
                    )}
                </Modal.Body>
            </Modal>
        </div >
    );
};

export default Client